import switchSvg from 'assets/icons/switch.svg';
import arrowUp from 'assets/icons/arrow_up.svg';
import arrowDown from 'assets/icons/arrow_down.svg';

export enum SortDir {
  NONE,
  ASC = 'asc',
  DESC = 'desc',
}

export const SortSettings: Record<SortDir, { nextDir: SortDir; icon: string }> = {
  [SortDir.NONE]: {
    nextDir: SortDir.ASC,
    icon: switchSvg,
  },
  [SortDir.DESC]: {
    nextDir: SortDir.NONE,
    icon: arrowDown,
  },
  [SortDir.ASC]: {
    nextDir: SortDir.DESC,
    icon: arrowUp,
  },
};
